import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, Collapse, Descriptions, Divider, Empty, Icon, Skeleton, Table, Tabs,} from "antd";
import moment from "moment";

import {getPOAgainstType} from "../../appRedux/actions/POReport";
import AccessControl from "../../components/AccessControl";
// import { getPOAgainstType } from "../../appRedux/actions";

const {Panel} = Collapse;
const {TabPane} = Tabs;

class PurchaseHistory extends Component {
  state = {
    typeName: "",
    unit: "",
    pos: null,
    resource: null,
    showResource: true,
  };
  componentDidMount = () => this.fetchData();

  fetchData = () => {
    console.log(`Fetching ....`);
    this.props.getPOAgainstType("spare", this.props.match.params.id);
  };

  toggleShowResource = () => {
    this.setState({
      showResource: !this.state.showResource,
    });
  };

  toggleShowHandler = () => {
    this.toggleShowResource();
    // console.log(this.state.showResource);
  };

  poViewButtonClickHandler = (poId) => {
    this.props.history.push(`/purchase-order/edit/${poId}`);
  };

  render() {
    let pos = <Skeleton active/>;
    let resource = <Skeleton active/>;
    let typeName = "";
    let unit = "";
    const loadMore = this.state.initLoading ? (
      <div
        style={{
          textAlign: "center",
          marginTop: 12,
          height: 32,
          lineHeight: "32px",
        }}
      >
        <Button onClick={this.onLoadMore}>loading more</Button>
      </div>
    ) : null;
    if(this.props.loading === false) {
      if(this.props.resource && Object.keys(this.props.resource).length > 0) {
        // console.log(this.props.resource);
        if(this.props.resource.type) {
          typeName = (
            <Descriptions.Item label="Type">
              {this.props.resource.type.name}
            </Descriptions.Item>
          );
        }
        if(this.props.resource.unitOfMeasurement) {
          unit = (
            <Descriptions.Item label="Unit">
              {this.props.resource.unitOfMeasurement.name}
            </Descriptions.Item>
          );
        }

        resource = (
          <Descriptions bordered column={2}>
            <Descriptions.Item label="Name">
              {this.props.resource.name}
            </Descriptions.Item>
            <Descriptions.Item label="Code">
              {this.props.resource.code}
            </Descriptions.Item>
            {typeName}
            {unit}
            {/* <Descriptions.Item label="Total Qty." span={2}>
              {this.props.resource.totalQuantity}
            </Descriptions.Item> */}
          </Descriptions>
        );
      } else resource = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>;
      if(this.props.datas && this.props.datas.length > 0) {
        const cols = [
          {
            title: "Date",
            dataIndex: "po_date",
            key: "po_date",
            sorter: (a, b) => {
              return moment(a.po_date, "DD-MM-YYYY").unix() -
                moment(b.po_date, "DD-MM-YYYY").unix();
            },
            // sortDirections: ["ascend", "descend"],
            // defaultSortOrder: "descend",
          },
          {
            title: "PO",
            dataIndex: "poNo",
            key: "poNo",
            sorter: (a, b) => ('' + a.poNo).localeCompare(b.poNo), // a.poNo.length - b.poNo.length,
            // sortDirections: ["ascend", "descend"],
          },
          // {
          //   title: "Invoice",
          //   dataIndex: "invoice",
          //   key: "invoice",
          //   sorter: (a, b) => a.invoice.length - b.invoice.length,
          //   sortDirections: ["ascend", "descend"]
          // },
          {
            title: "Vendor",
            dataIndex: "vendor",
            key: "vendor",
            // render: (vendor) => vendor,
            sorter: (a, b) => ('' + a.vendor).localeCompare(b.vendor)
            // sortDirections: ["ascend", "descend"],
          },
          {
            title: "Loc",
            dataIndex: "location",
            key: "location",
            render: (location) => location && location.name,
            sorter: (a, b) => ('' + a.location.name).localeCompare(b.location.name)
            // sortDirections: ["ascend", "descend"],
          },
          {
            title: "Sub Loc",
            dataIndex: "client",
            key: "client",
            render: (client) => client && client.name,
            sorter: (a, b) => ('' + a.client && a.client.name).localeCompare(b.client && b.client.name)
          },
          {
            title: "Rate",
            dataIndex: "rate",
            key: "rate",
            render: (_, row) => row.rate.toFixed(2),
            sorter: (a, b) => a.rate - b.rate,
            // sortDirections: ["descend"],
          },
          {
            title: "Qty.",
            dataIndex: "quantity",
            key: "quantity",
            sorter: (a, b) => a.quantity - b.quantity,
            // sortDirections: ["descend"]
          },
          {
            title: "Total",
            dataIndex: "total",
            key: "total",
            render: (_, record) => (record.rate * record.quantity).toFixed(2),
            sorter: (a, b) => (a.rate * a.quantity) - (b.rate * b.quantity),
          },
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (_, record) => (
              <div>
                <AccessControl
                  resource={"PurchaseOrder"}
                  permissionNeeded={"u"}
                  roles={this.props.authUser ? this.props.authUser.roles : []}
                  render={(props) => {
                    return (
                      <Button
                        type="primary"
                        size="small"
                        onClick={() =>
                          this.poViewButtonClickHandler(record.poId)
                        }
                      >
                        View
                      </Button>
                      // <Link
                      //   to={"/purchase-order/edit/" + record.poId}
                      //   target="_blank"
                      // >
                      //   {record.poNo}
                      // </Link>
                    );
                  }}
                />
              </div>
            ),
          },
        ];

        const poDatas = (this.props.datas || [])
          .map((data, index) => {
            const spares = (data.spareParts || []).filter(
              (sp) => sp.type === this.props.match.params.id
            );
            const poData = {
              // key: `${data.poNo}-${moment(data.invoiceDate).format("DD-MM-YYYY")}`,
              po_date: moment(data.invoiceDate).format("DD-MM-YYYY"),
              poNo: data.poNo,
              poId: data._id,
              invoice: data.invoiceNumber,
              vendor: data.vendor && data.vendor.name ? data.vendor.name : ""
            };
            // // console.log(spares);
            const sparesUpdated = (spares || []).map((spr) => {
              return {...spr, ...poData};
            });
            return sparesUpdated;
          })
          .flat();

        pos =
          poDatas && poDatas.length > 0 ? (
            <Table
              dataSource={poDatas}
              // pagination={false}
              pagination={{pageSize: 10}}
              columns={cols}
              loading={this.props.loading}
              // scroll={{ y: 250 }}
              rowKey={(record) =>
                record.poNo +
                record.type +
                record.location._id +
                (record.client && record.client._id)
              }
            />
          ) : null;
      } else pos = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>;
    }

    return (
      <div>
        <Divider>
          <a href="#" onClick={this.toggleShowHandler}>
            Spare Part Details
            <Icon type="down-square"/>
          </a>
        </Divider>
        {this.state.showResource ? resource : null}
        <Divider>PO Histories</Divider>
        {pos}
      </div>
    );
  }
}

const mapStateToProps = ({auth, poReport, commonData}) => {
  return {
    authUser: auth.authUser,
    total: poReport.total,
    datas: poReport.datas,
    resource: poReport.resource,
    loading: commonData.loading,
    pageNo: poReport.pageNo,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getPOAgainstType,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(PurchaseHistory);
